import LinkTextM from "@common/components/text/LinkTextM";
import TextM from "@common/components/text/TextM";
import React from "react";

export function CGUText({ fontSize = 12, style = {} }) {
    return (
        <TextM
            fontSize={fontSize}
            style={{
                textAlign: "center",
                ...style,
            }}
            wrap
        >
            En continuant, j'accepte les{" "}
            <LinkTextM url="https://masteur.com/cgu">
                Conditions générales d'utilisation
            </LinkTextM>{" "}
            de Masteur. Je confirme avoir plus de 15 ans. Dans le cas contraire,
            je confirme avoir l'autorisation d'un parent pour utiliser ce
            service.
        </TextM>
    )
}
